import { Filter } from '@uni-space/uni-components';

import { sort_center_api } from '@shared/api';
import { FetchCtx } from '@shared/types/api';
import { PageList } from '@shared/types/filter';
import { makeQueryString } from '@shared/utils/pagging';

import {
  AcceptanceActBagsHttpResponse,
  AcceptanceActDto,
  AcceptanceActStatus,
  AcceptanceBagHttpRequest,
  AcceptanceBagHttpResponse,
  CreateAcceptanceActHttpRequest,
  CreateAcceptanceActHttpResponse,
  GetAllAcceptanceActsHttpResponse,
  GetAllManifestsHttpResponse,
  ManifestDto,
  ManifestOperationHttpResponse,
  NotAcceptedManifestBagsHttpResponse,
} from '../model/manifestAcceptance';

// ---- Манифесты ----

/** Подсказки для модалки создания приёмки: манифесты по началу номера, любые статусы */
export async function searchManifests(prefix: string, size = 8, ctx?: FetchCtx): Promise<PageList<ManifestDto>> {
  const url: string = `v1/manifests?` + makeQueryString(0, size, [{ name: 'number', value: prefix }]);
  const result = await sort_center_api<GetAllManifestsHttpResponse>(url, { signal: ctx?.signal });
  return result.data;
}

export async function getNotAcceptedManifestBags(manifestNumber: string): Promise<NotAcceptedManifestBagsHttpResponse> {
  const url = `v1/manifests/${manifestNumber}/bags/not-accepted`;
  const result = await sort_center_api.get<NotAcceptedManifestBagsHttpResponse>(url);
  return result.data;
}

/** Сканирование мешка в приёмку — общий эндпоинт для приёмки по манифесту и без него */
export async function acceptBagInManifest(
  bagNumber: string,
  payload: AcceptanceBagHttpRequest,
): Promise<AcceptanceBagHttpResponse> {
  const url = `v1/manifests/${bagNumber}/acceptance`;
  const result = await sort_center_api.post<AcceptanceBagHttpResponse>(url, payload);
  return result.data;
}

// ---- Приёмки ----

export async function getAllAcceptanceActs(
  page: number | undefined,
  pageSize: number | undefined,
  filters: Filter[] | undefined,
  status: AcceptanceActStatus,
  ctx?: FetchCtx,
): Promise<PageList<AcceptanceActDto>> {
  const filter = filters ? [...filters, { name: 'status', value: status }] : [{ name: 'status', value: status }];
  const url: string = `v1/acceptance-acts?` + makeQueryString(page, pageSize, filter);
  const result = await sort_center_api<GetAllAcceptanceActsHttpResponse>(url, { signal: ctx?.signal });
  return result.data;
}

/** Открывает приёмку; с манифестом сервер делает прибытие и старт одним шагом */
export async function createAcceptanceAct(
  payload: CreateAcceptanceActHttpRequest,
): Promise<CreateAcceptanceActHttpResponse> {
  const result = await sort_center_api.post<CreateAcceptanceActHttpResponse>('v1/acceptance-acts', payload);
  return result.data;
}

export async function closeAcceptanceAct(acceptanceActId: number): Promise<ManifestOperationHttpResponse> {
  const url = `v1/acceptance-acts/${acceptanceActId}/close`;
  const result = await sort_center_api.post<ManifestOperationHttpResponse>(url);
  return result.data;
}

export async function getAcceptanceActBags(acceptanceActId: number): Promise<AcceptanceActBagsHttpResponse> {
  const url = `v1/acceptance-acts/${acceptanceActId}/bags`;
  const result = await sort_center_api.get<AcceptanceActBagsHttpResponse>(url);
  return result.data;
}
